import { getTelematicPropertyFromEquipmentAndRenderTelematics } from 'react/utils/telematicsUtils';
import { getResourceTo, toastNotification } from 'react/utils/utils';

Greenmile.TrackEquipment = Greenmile.TrackEquipment || {};

Greenmile.TrackEquipment.Request = function () {
    const showMessageNoMarkers = function () {
      toastNotification.addToast({
        id: 'track-equipment-no-coordinates',
        type: 'warning',
        variant: 'secondary',
        data: {
          title: getResourceTo('alertgenericmodal.header.title.default'),
          description: getResourceTo('trackEquipment.no.coordinates'),
        }
      });
      $("#trackEquipmentMapContainer").append($(".toast"));
      const contentMarginLeft = ($("#trackEquipmentMapContainer .toast").width() / 2) * -1;
      const marginTop = ($("#trackEquipmentMapContainer .toast").height() / 2) * -1;

      $("#trackEquipmentMapContainer .toast").css("margin-top", (marginTop - $("#trackEquipmentMapContainer .toast").height() * 2) - 70);
      $("#trackEquipmentMapContainer .toast").css("margin-left", contentMarginLeft - $("#trackEquipmentMapContainer .toast").width() / 2);
    };

    this.getEquipments = function (filter, callback) {
      const form = App.Forms.TrackEquipmentMaps.form;

      try {

          const entity                = "TrackEquipmentMaps";
          const tableLayout           = Greenmile.TrackEquipment.Utils.getColumns();
          const equipmentsCollection  = new App.Collections.Equipments();
          const projection = Monet.projectionBuilder(
            Greenmile.TrackEquipment.Utils.dataMapper,
            App.Forms.TrackEquipmentMaps.pagination
          );

          form.triggerLoadingBtns();

          if(!filter) {
            callback(entity, tableLayout, equipmentsCollection, true);
            return;
          }
          const urlRetrieveEquipments = 'Equipment/restrictions?criteria=' + projection;
          const organizationCriteria  = {
              attr: "organization.id",
              eq: parseInt(filter.organization.id, 10)
          };
          const descriptionCriteria = {
            or: [
              {
                attr: "key",
                eq: filter.key.id,
                  matchMode: "ANYWHERE"
              },
              {
                  attr: "description",
                  eq: filter.description.id,
                  matchMode: "ANYWHERE"
              }
            ]
          };
          const bodyString = {
            criteriaChain: [
              { and: [] }
            ]
          };

          if (filter.organization.id) {
            bodyString.criteriaChain[0].and.push(organizationCriteria);
          }

          bodyString.criteriaChain[0].and.push(descriptionCriteria);

          //Using to create Sort of Grid
          const filterBuilder = new Monet.UI.FilterBuilder();
          filterBuilder.customNameSpace = "TrackEquipmentMaps";
          bodyString.sort = filterBuilder.getSort();

          const body = JSON.stringify(bodyString);

          const ajax = new Monet.Ajax();
          ajax.url = urlRetrieveEquipments;
          ajax.method = 'POST';
          ajax.data = body;
          ajax.success = (data) => {
              form.triggerLoadingBtns();
              equipmentsCollection.add(data);
              if (callback) {
                  callback(entity, tableLayout, equipmentsCollection, true);
              } else {
                  const error = new Monet.Exception.ReturnError(this, "No callback to execute after get equipments.");
                  error.console();
              }
          };
          ajax.error = () => {
              form.triggerLoadingBtns();
          };
          ajax.send();
      } catch (e) {
          form.triggerLoadingBtns();
          const error = new Monet.Exception.ReturnError(this, "Error on get equipments.", e);
          error.console();
      }
    };

    this.getHeightToTabInformation = function () {

        let height = null;
        const storage = new Greenmile.Storage.StoreMapPosition();
        const preferences = storage.getTrackEquipmentPreferencies();

        if (preferences?.tabsHeight) {
            height = preferences.tabsHeight;
        }
        return height;
    };

    const renderTelematic = (
            equipmentId,
            positionSources,
            container,
            sessionData
    ) => {
      getTelematicPropertyFromEquipmentAndRenderTelematics(
        equipmentId,
        positionSources,
        container,
        sessionData
      );
    };

    this.renderTelematicChart = function (equipmentId) {

      const screenTab = '#TrackEquipmentMaps';
      const height = this.getHeightToTabInformation();
      const selectorTelematic = screenTab + ' #TrackEquipmentTelematic';
      const tabInstance = $(screenTab + ' #tabsRouteDetail').tabs('instance');

      if (equipmentId && tabInstance) {
        Monet.Session.TrackEquipmentMaps.equipment = { id: equipmentId };
        renderTelematic(
          equipmentId,
          Monet.Session.TrackEquipmentMaps.positionSources,
          document.querySelector(selectorTelematic),
          Monet.Session.TrackEquipmentMaps
        );
      }

      $(screenTab + " #tabsRouteDetail").tabs({
        create: function () {
          const container = document.querySelector(selectorTelematic);
          const resizeCallback = (event, ui) => {
            const caption = document.querySelector(
              '#TrackEquipmentMaps #track-equipment-caption'
            );

            const uiHeight = ui.size.height;
            const height = uiHeight - 35;

            container.style.height = `${height}px`;
            caption.style.bottom = `${uiHeight + 10}px`;
            telematicView.updateHeightElements(height);
          };

          const stopCallback = (event, ui) => {
            const height = ui.size.height;
            const storage = new Greenmile.Storage.StoreMapPosition();
            const preferences = storage.getTrackEquipmentPreferencies();

            this.style.top = '';

            App.Views.TrackEquipmentMaps.adjustHeightMap();

            preferences.tabsHeight = height;
            storage.setTrackEquipmentPreferencies(preferences);
          };

          if (container) {
            container.innerHTML = '';
            container.style.height = height - 35 + 'px';
          }

          renderTelematic(
            equipmentId,
            Monet.Session.TrackEquipmentMaps.positionSources,
            container,
            Monet.Session.TrackEquipmentMaps
          );

          $(screenTab + " #tabsRouteDetail").resizable({
            handles: "n",
            minHeight: Monet.Utils.getHeightDefaultToTab(),
            maxHeight: window.innerHeight - (75 + 28 + 70),
            resize: resizeCallback,
            stop: stopCallback
          });
        }
      });

    };

    this.getEquipmentActualPath = function (equipment, initialDateISOString, finalDateISOString) {
        if (initialDateISOString && finalDateISOString && equipment) {
            const equipmentId = equipment.idOfObject;

            try {
                const success = (equipmentID, positionSources) => {

                    const coordinates = positionSources?.at(0)?.get('coordinates') ||
                      new App.Collections.Coordinates();
                    const namespace = Monet.Session.TrackEquipmentMaps;
                    Monet.Session.TrackEquipmentMaps.positionSources = positionSources;
                    Monet.Session.TrackEquipmentMaps.coordinates = coordinates;
                    
                    namespace.equipments = {};
                    namespace.equipments[equipmentId] = coordinates;

                    const infoRoute = new Greenmile.Coordinates.GeneralFunctions(namespace);
                    const options = {
                        kind: 'TRACK_EQUIPMENT',
                        eventToClickArrow: function (e) {
                            const option = {
                                sourceSessionData: namespace
                            };

                            const cDistance = new Greenmile.Toolbar.Map.DistanceBetweenCoords(undefined, namespace.map, option);
                            cDistance.markerClickHandler(e);
                        }
                    };
                    const pathColors = ['#FF41A6', '#FF7D00'];
                    positionSources?.models.forEach((positionSource, index) => {
                      const positionSourceCoordinates =
                        positionSource.get('coordinates');
                      options.color = pathColors[index];

                      infoRoute.generateActualRouteInfo(
                        namespace.map,
                        positionSourceCoordinates,
                        options,
                        equipmentId
                      );
                    });
                    const models = coordinates.models;

                    this.renderTelematicChart(
                      equipment.idOfObject
                    );

                    if (models.length) {
                        const coordinate = coordinates.last();
                        equipment.speedKmh = coordinate.get('speedKmh');
                        equipment.equipmentKey = coordinate.get('equipmentKey');
                        Greenmile.RouteDetail.Util.addTruckMarkerToMap(coordinate, equipment, namespace, 'PRINCIPAL_EQUIPMENT');
                        App.Views.TrackEquipmentMaps.fitBounds(models);
                    } else {
                        showMessageNoMarkers();
                        Greenmile.RouteDetail.Util.removeTruckMarkerFromMap(Monet.Session.TrackEquipmentMaps, equipmentId);
                    }
                };

                const coordinates = new Greenmile.Coordinates.GeneralFunctions(Monet.Session.TrackEquipmentMaps);
                coordinates.requestCoordinateByEquipment(equipmentId, initialDateISOString, finalDateISOString, success);

            } catch (e) {
                const error = new Monet.Exception.ReturnError(this, "Error on get equipments actual path.");
                error.console();
            }
        }
    };
};
